<app-header navScreen="Home" class="mb-5"></app-header>

<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div class="row text-center ka-em-payment-details-header">
    <h2 style="margin: 0;">View Profile</h2>
</div>
<div class="ka-em-profile-content">
    <form [formGroup]="paymentForm">
        <div class="row">
            <div class="col-md-3 ka-em-profile-text-field">
                <label class="text-left ka-float-left ka-custom-margin-lable-bottom" for="ProfileId">Enter
                    ProfileId</label>
                <input type="text" id="ProfileId" formControlName="profileId" mdbInput class="form-control"
                    placeholder="Enter ProfileId"
                    (keyup)="captureInputValue($event)" (change)="onChange($event)"
                    (keydown.enter)="submitProfileId(paymentForm.value['profileId'])">
                    <div *ngIf="paymentForm.controls['profileId'].errors && !paymentForm.controls['profileId'].pristine"
                class="error-msg1">
                <div [hidden]="!paymentForm.controls['profileId'].errors.pattern">
                    Enter Valid Profile ID!
                </div>
            </div>
            </div>
            <div class="col-md-9" style="padding: 20px;" *ngIf="loginData?.isManagement === 1">
                <div class="action-buttons">
                    <button mdbBtn [disabled]="!paymentForm.valid"
                        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                        style="width:auto" mdbWavesEffect type="submit"
                        (click)="submitProfileId(paymentForm.value['profileId'])">With Contacts</button>
                    <button mdbBtn [disabled]="!paymentForm.valid"
                        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                        style="width:auto; margin-left: 5px !important;" mdbWavesEffect type="submit"
                        (click)="submitProfileId(paymentForm.value['profileId'], 0)">Without Contacts</button>    
                    <button mdbBtn [disabled]="!paymentForm.valid"
                        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                        style="width:auto; margin-left: 5px !important;" mdbWavesEffect type="submit"
                        (click)="submitProfileId(paymentForm.value['profileId'])">View Profile</button>     
                    <button mdbBtn *ngIf="modifiedData.length > 0"
                        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                        style="width:auto; margin-left: 5px !important;" mdbWavesEffect type="submit" (click)="print()"
                        [disabled]="modifiedData.length==0">Print</button>                   
                </div>
            </div>

            <!-- <div class="col-md-5">
                <div class="action-buttons">
                    <button mdbBtn
                        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                        style="width:auto" mdbWavesEffect type="submit" (click)="print()">Print</button>
                </div>
            </div> -->
        </div>
    </form>
</div>



<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div class="container disable-select" *ngIf="modifiedData.length > 0">
    <div class="row">

    </div>


    <div class="ka-em-content">
        <div class="ka-em-header-content">
            <img style="height: 150px; width: 150px; cursor: pointer; margin-left: 5px;"
                *ngIf="primaryObject['ApplicationPhotoPath']!=null" src="{{primaryObject['ApplicationPhotoPath']}}"
                alt="" (click)="requestViewPhoto(primaryObject['Cust_ID'])">
            <img style="height: 150px; width: 150px; cursor: pointer;"
                *ngIf="primaryObject['ApplicationPhotoPath']===null && primaryObject['GenderID']===1"
                src="../../../assets/img/profile/male.PNG" alt="">
            <img style="height: 150px; width: 150px; cursor: pointer;"
                *ngIf="primaryObject['ApplicationPhotoPath']===null && primaryObject['GenderID']===2"
                src="../../../assets/img/profile/female.PNG" alt="">
            <!-- <div class="col ka-em-profile-image">
                <img style="height: 150px; width: 150px; cursor: pointer;"
                    *ngIf="primaryObject['ApplicationPhotoPath']!=null" src="{{primaryObject['ApplicationPhotoPath']}}"
                    alt="">
                <img style="height: 150px; width: 150px; cursor: pointer;"
                    *ngIf="primaryObject['ApplicationPhotoPath']===null && primaryObject['GenderID']===1"
                    src="../../../assets/img/profile/male.PNG" alt="">
                <img style="height: 150px; width: 150px; cursor: pointer;"
                    *ngIf="primaryObject['ApplicationPhotoPath']===null && primaryObject['GenderID']===2"
                    src="../../../assets/img/profile/female.PNG" alt="">
            </div> -->
            <div class="ka-em-innercontent">
                <!-- <h6 class="ka-em-profileName">{{primaryObject['NAME']}} <span *ngIf="primaryObject['OnlyChild']!=0">(Only Child)</span> (Profile Id: {{primaryObject['ProfileID']}})
                </h6> -->

                <h6 class="ka-em-profileName">{{primaryObject['NAME']}}
                    <span *ngIf="primaryObject['OnlyChild']==1">(Only Child)</span>
                    (Profile ID: {{primaryObject['ProfileID']}})
                </h6>

                <p *ngIf="aboutObject &&  primaryObject['GenderID']===2" style="font-size: 14px;
                font-weight: bold;">
                    About my Daughter
                </p>
                <p *ngIf="aboutObject &&  primaryObject['GenderID']===1" style="font-size: 14px;
                font-weight: bold;">
                    About my Son
                </p>
                <p *ngIf="aboutObject">
                    <span>{{aboutObject['Aboutyourself']}}</span>
                </p>
            </div>
            <div>
                <img style="height: 150px; width: 150px; cursor: pointer;" matTooltip="HoroscopeImage"
                    *ngIf="primaryObject['HoroscopeImage']!=null" src="../../../assets/img/profile/150Astro.jpg" alt=""
                    (click)="naviagteToHoroscope()" matTooltipPosition="left">

                <img style="height: 150px; width: 150px; opacity: 0.1;" *ngIf="primaryObject['HoroscopeImage']==null"
                    matTooltip="HoroscopeImage" matTooltipPosition="left" src="../../../assets/img/profile/150Astro.jpg"
                    alt="">
            </div>

            <!-- <div class="col ka-em-profile-image">
                <img style="height: 150px; width: 150px; cursor: pointer;" matTooltip="HoroscopeImage" *ngIf="primaryObject['HoroscopeImage']!=null"
                    src="../../../assets/img/profile/150Astro.jpg" alt="" (click)="naviagteToHoroscope()">
               
                <img style="height: 150px; width: 150px; opacity: 0.1;" *ngIf="primaryObject['HoroscopeImage']==null"
                    src="../../../assets/img/profile/150Astro.jpg" alt="">

            </div> -->



        </div>
        <!-- <div class="row">

            <div class="col ka-em-profile-image">
                <img style="height: 150px; width: 150px; cursor: pointer;"
                    *ngIf="primaryObject['ApplicationPhotoPath']!=null" src="{{primaryObject['ApplicationPhotoPath']}}"
                    alt="">
                <img style="height: 150px; width: 150px; cursor: pointer;"
                    *ngIf="primaryObject['ApplicationPhotoPath']===null && primaryObject['GenderID']===1"
                    src="../../../assets/img/profile/male.PNG" alt="">
                <img style="height: 150px; width: 150px; cursor: pointer;"
                    *ngIf="primaryObject['ApplicationPhotoPath']===null && primaryObject['GenderID']===2"
                    src="../../../assets/img/profile/female.PNG" alt="">
            </div>

            <h6 class="ka-em-profileName">{{primaryObject['NAME']}} (Profile Id: {{primaryObject['ProfileID']}})</h6>
            <div class="col ka-em-profile-image" matTooltip="Horoscope">
                <img style="height: 150px; width: 150px; cursor: pointer;" tooltip="Horoscope"
                    *ngIf="primaryObject['HoroscopeImage']!=null" src="../../../assets/img/profile/150Astro.jpg" alt=""
                    (click)="naviagteToHoroscope()">
                <img style="height: 150px; width: 150px; opacity: 0.1;" tooltip="Horoscope"
                    *ngIf="primaryObject['HoroscopeImage']==null" src="../../../assets/img/profile/150Astro.jpg" alt="">

            </div>



        </div> -->
        <div *ngFor="let eachHeader of modifiedData; let i = index">
            <div class="row ka-em-headings">
                <div class="col-md-12 ka-em-heading-value">
                    <p><span style="visibility: hidden;height: 0px;
                        display: block;">hide</span></p>
                    <div><strong> {{eachHeader['key']}}</strong></div>
                    <p><span style="visibility: hidden;height: 0px;
                        display: block;">hide</span></p>
                </div>
            </div>

            <div
                [ngClass]="(eachHeader['key']==='My Basic Details' || eachHeader['key']==='Partner Preferences details') ? 'row  ka-em-content-values' : 'ka-em-content-values'">
                <div *ngFor="let eachValue of eachHeader['data']; let i=index"
                    [ngClass]="(eachHeader['key']==='My Basic Details' || eachHeader['key']==='Partner Preferences details') ? 'col-md-4' : ''">
                    <div class="ka-viewprofile-details"
                        *ngIf="(eachHeader['key']==='My Basic Details' || eachHeader['key']==='Partner Preferences details')">
                        <!-- <span> <strong>{{eachValue['columnname']}}</strong> </span> <span
                            style="padding-left: 1%;" >:</span> <span style="padding-left: 1%;" 
                            [innerHTML]="eachValue['value'] | limitTo : '20'"></span> -->

                        <span style="display:inline-block; width: 100px!important;"><strong>{{eachValue['columnname']}}</strong></span>
                        <span style="padding-left: 1%;"> : </span>
                        <span style="padding-left: 1%; color:#06347e" [innerHTML]="eachValue['value'] | limitTo : '20'"></span>


                    </div>
                    <div>
                        <p>
                        <span class="ka-viewprofile-details"
                            *ngIf="(eachHeader['key']!='My Basic Details' && eachHeader['key']!='Partner Preferences details')">
                            <span style="display:inline-block; width: 150px!important;"><strong>{{eachValue['columnname']}}</strong></span>
                            <span
                                *ngIf="eachHeader['key']=='My Profession & Education Information'">
                            </span>
                            <span style="padding-left: 1%;"
                                *ngIf="eachHeader['key']!='My Profession & Education Information'"> : </span> <span
                                style="padding-left: 1%; color:#06347e" [innerHTML]="eachValue['value']  ">-</span>
                        </span>
                    </p>
                    </div>

                </div>

            </div>


        </div>
    </div>
</div>


<div class="container disable-select" style="display:none;">
    <div class="ka-em-content" id="print-section" #content>
        <div class="row" style="text-align: center;" *ngIf="printMyProfileBasicData.length>0">
            <span style="font-weight: bold;text-transform: uppercase;">{{ primaryObject['NAME']}}</span>
            <span style="font-weight: bold;margin-left: 4px;">  Profile ID : {{primaryObject['ProfileID']}} 
         </span>
        </div>
        <div class="row" *ngIf="printMyProfileBasicData.length>0" style="padding-top: 10px; font-size: 14px !important;font-family: 'Open Sans', sans-serif !important;">
            <div class="col-lg-9 col-md-10 col-sm-10">
                <div class="col-lg-4 col-xs-4 col-sm-4 col-md-4" style="margin-bottom: 4px;">
                    <span style="font-weight: bold;">{{printMyProfileBasicData[0]['columnname']}}</span> :
                    <span style="text-transform: capitalize;">{{printMyProfileBasicData[0]['value']}}</span>

                </div>
                <div class="col-lg-4 col-xs-4 col-sm-4 col-md-4" style="margin-bottom: 4px;">
                    <span style="font-weight: bold;">{{printMyProfileBasicData[1]['columnname']}}</span> :
                    <span style="text-transform: capitalize;">{{printMyProfileBasicData[1]['value']}}</span>

                </div>
                <div class="col-lg-4 col-xs-4 col-sm-4 col-md-4" style="margin-bottom: 4px;">
                    <span style="font-weight: bold;">{{printMyProfileBasicData[2]['columnname']}}</span> :
                    <span style="text-transform: capitalize;">{{printMyProfileBasicData[2]['value']}}</span>
                </div>
                <div *ngFor="let basicObject of printMyProfileBasicData; let i=index">
                    <div class="col-lg-4 col-xs-4 col-sm-4 col-md-4" style="margin-bottom: 4px;"
                     *ngIf="i>2 && i < printMyProfileBasicData.length">
                        <span style="font-weight: bold;">{{printMyProfileBasicData[i]['columnname']}}</span> :
                        <span style="text-transform: capitalize;">{{printMyProfileBasicData[i]['value']}}</span>
    
                    </div>
    
                </div>
            </div>
            <div class="col-lg-2 col-xs-2 col-md-2 col-sm-2">
                <img *ngIf="primaryObject['ApplicationPhotoPath']"
                    style="height: 100px; width: 100px; cursor: pointer;"
                    src="{{primaryObject['ApplicationPhotoPath']}}" alt="">
            </div>

        </div>
        <div class="ka-em-print-screen-data" style="padding-top: 2% !important;"
            *ngFor="let eachHeader of printData; let i = index">
            <div class="row">
                <div style="border: 1px solid gainsboro;  margin: 5px 0px;"
                    [ngClass]="eachHeader['key'] === 'Partner Preferences details'? 'col-md-12': 'col-md-12'">
                    <span style="font-weight: bold;font-family: 'Open Sans', sans-serif !important;">{{eachHeader['key']}}</span>
                </div>
            </div>
            <div
                [ngClass]="(eachHeader['key']==='My Basic Details' || eachHeader['key']==='Partner Preferences details') ? 'row  ka-em-print-value' : 'ka-em-print-value'">
                <div *ngFor="let eachValue of eachHeader['data']; let i=index"
                    [ngClass]="(eachHeader['key']==='My Basic Details' || eachHeader['key']==='Partner Preferences details' || eachHeader['key']==='My Location Information') ? 'col-md-4' : ''">
                    <div class="row" style="margin-bottom: 4px;"
                        *ngIf="(eachHeader['key']==='My Basic Details' || eachHeader['key']==='Partner Preferences details')">
                        <span style="font-size: 14px;font-family: 'Open Sans', sans-serif !important; font-weight: bold;">{{eachValue['columnname']}} </span> <span
                            style="padding-left: 1%; font-size: 14px;">:</span> <span
                            style="padding-left: 1%; font-size: 14px;font-family: 'Open Sans', sans-serif !important;"
                            [innerHTML]="eachValue['value'] | limitTo : '20'"></span>

                    </div>
                    <div class="row" style="margin-bottom: 4px;"
                        *ngIf="(eachHeader['key']!='My Basic Details' && eachHeader['key']!='Partner Preferences details')">
                        <span style="font-size: 14px;font-family: 'Open Sans', sans-serif !important;font-weight: bold;">{{eachValue['columnname']}}</span> <span
                            style="padding-left: 1%; font-size: 14px;"
                            *ngIf="eachHeader['key']!='My Profession & Education Information'">:</span> <span
                            style="padding-left: 1%; font-size: 14px;font-family: 'Open Sans', sans-serif !important;" [innerHTML]="eachValue['value']"></span>

                    </div>
                </div>

            </div>
      
            




            
        </div>

        <div class="row" style="margin-top: 2% !important;"  *ngIf="aboutObject">
            <div class="col-md-12" style="border: 1px solid gainsboro; margin: 5px 0px;">
                <span style="font-size: 16px; font-weight: bold;font-family: 'Open Sans', sans-serif !important;">
                    About my Daughter </span> </div> 
            <div class="col-md-12" *ngIf="aboutObject">
             {{aboutObject['Aboutyourself']}}
            </div>
        </div>
    </div>
    
</div>

<div mdbModal #alertModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="alertModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{alertMessage}} </p>

                            <div class="action-buttons">
                                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                    mdbWavesEffect type="submit" (click)="alertModal.hide()">close
                                </button>



                            </div>

                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>
<div class="col-md-12" *ngIf="glleryClicked">
    <!-- <mdb-icon far icon="minus-square" (click)="glleryClicked = !glleryClicked"></mdb-icon> -->
    <app-image-slider [profileDataImages]="profileDataImages" (closeEventTrigger)="closeModalPreviewImage($event)">

    </app-image-slider>
</div>